import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import "../styles/EditarPedidoModal.css";
import { AutoComplete } from "primereact/autocomplete";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const EditarPedidoModal = ({ isOpen, onClose, pedido, language, onSave }) => {
  const [formData, setFormData] = useState({});

  const translations = {
    es: {
      titulo: "Editar Pedido",
      guardar: "Guardar",
      cancelar: "Cancelar",
      campos: {
        idpedido: "ID Pedido",
        iCodigoCliente: "Cliente",
        fecha_pedido: "Fecha del Pedido",
        fecha_llegada_a_bodega: "Fecha Llegada a Bodega",
        fecha_llegada_a_bodega_estimada: "Fecha Llegada Estimada a Bodega",
        origen: "Origen",
        destino: "Destino",
        descripcion_mercancia: "Descripción de la Mercancía",
        peso_bruto: "Peso Bruto",
        peso_neto: "Peso Neto",
        estadoPedido: "Estado del Pedido",
        observaciones: "Observaciones",
        proveedor: "Proveedor",
        iCantidad_Cajas_P: "Cantidad de Cajas",
        dMetrosCubicos: "Metros Cúbicos",
        sMarca: "Marca",
        sTM: "Tipo Mercancía",
        sRegistroIngreso: "Registro Ingreso",
      },
    },
    en: {
      titulo: "Edit Order",
      guardar: "Save",
      cancelar: "Cancel",
      campos: {
        idpedido: "Order ID",
        iCodigoCliente: "Client",
        fecha_pedido: "Order Date",
        fecha_llegada_a_bodega: "Receiving Date",
        fecha_llegada_a_bodega_estimada: "Estimated Receiving Date",
        origen: "Origin",
        destino: "Destination",
        descripcion_mercancia: "Merchandise Description",
        peso_bruto: "Gross Weight",
        peso_neto: "Net Weight",
        estadoPedido: "Order Status",
        observaciones: "Observations",
        proveedor: "Provider",
        iCantidad_Cajas_P: "Box Quantity",
        dMetrosCubicos: "Cubic Meters",
        sMarca: "Brand",
        sTM: "Type of Goods",
        sRegistroIngreso: "Entry Record",
      },
    },
    zh: {
      titulo: "编辑订单",
      guardar: "保存",
      cancelar: "取消",
      campos: {
        idpedido: "订单编号",
        iCodigoCliente: "客户",
        fecha_pedido: "订单日期",
        fecha_llegada_a_bodega: "到达日期",
        fecha_llegada_a_bodega_estimada: "预计到达日期",
        origen: "起源",
        destino: "目的地",
        descripcion_mercancia: "商品描述",
        peso_bruto: "毛重",
        peso_neto: "净重",
        estadoPedido: "订单状态",
        observaciones: "备注",
        proveedor: "供应商",
        iCantidad_Cajas_P: "箱子数量",
        dMetrosCubicos: "立方米",
        sMarca: "品牌",
        sTM: "货物类型",
        sRegistroIngreso: "入库记录",
      },
    },
  };

  const t = translations[language] || translations.es;
  const [clientes, setClientes] = useState([]);
  const [allClientes, setAllClientes] = useState([]); // Nuevo estado para todos los clientes
  const [clienteEditado, setClienteEditado] = useState(false);
  const [imagenes, setImagenes] = useState([]);
  const [loadingImagenes, setLoadingImagenes] = useState(false);

  useEffect(() => {
    if (pedido) {
      console.log("📥 pedido recibido:", pedido);
      setFormData({ ...pedido });
    }
  }, [pedido]);

  useEffect(() => {
    console.log("🟢 formData actualizado:", formData);
  }, [formData]);

  // Cargar todos los clientes activos una única vez al abrir el modal
  useEffect(() => {
    if (isOpen) {
      const fetchAllClientes = async () => {
        try {
          const response = await fetchWithAuth(
            `${API_URL}/api/clientes-activos`,
          ); // Sin parámetro 'q'
          const data = await response.json();
          const clientesFormateados = data.map((cliente) => ({
            ...cliente,
            label: `${cliente.sNombreCliente} (${cliente.sMarca})`,
          }));
          setAllClientes(clientesFormateados);
        } catch (error) {
          console.error("Error al cargar todos los clientes:", error);
        }
      };
      fetchAllClientes();
    }
  }, [isOpen]);
  // [EXPERT_FIX]: Carga de fotos de mercancía al abrir el modal
  useEffect(() => {
    if (isOpen && formData.idpedido) {
      const fetchFotos = async () => {
        setLoadingImagenes(true);
        try {
          const response = await fetchWithAuth(
            `${API_URL}/api/imagenessubidas/${formData.idpedido}`
          );
          if (response.ok) {
            const data = await response.json();
            setImagenes(data.imagenes || []);
          } else {
            setImagenes([]);
          }
        } catch (error) {
          console.error("Error al cargar fotos:", error);
          setImagenes([]);
        } finally {
          setLoadingImagenes(false);
        }
      };
      fetchFotos();
    } else if (!isOpen) {
      setImagenes([]); // Limpiar al cerrar
    }
  }, [isOpen, formData.idpedido]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const buscarClientes = (event) => {
    // Ya no es async
    const query = event.query.trim().toLowerCase();

    if (query.length < 2) {
      setClientes([]);
      return;
    }

    // Filtrar clientes desde allClientes
    const filteredClientes = allClientes.filter(
      (cliente) =>
        cliente.sNombreCliente.toLowerCase().includes(query) ||
        cliente.sMarca.toLowerCase().includes(query),
    );

    setClientes(filteredClientes);
  };

  const handleClienteSelect = (e) => {
    const cliente = e.value;
    setClienteEditado(false); // ✅ Se seleccionó correctamente, no es edición manual inválida
    setFormData((prev) => ({
      ...prev,
      iCodigoCliente: parseInt(cliente.iCodigo, 10),
      sNombreCliente: cliente.sNombreCliente,
      sMarca: cliente.sMarca,
      destino: cliente.destino || "",
    }));
  };

  // Asegurar que el formato de los clientes para el AutoComplete sea consistente (con la propiedad label)
  // Esto ya se maneja en la carga inicial de allClientes y en la función buscarClientes.
  // No se requiere un cambio adicional aquí, pero se deja el comentario para referencia.

  const handleSave = () => {
    console.log("Datos enviados al guardar:", formData);
    // Validación previa
    if (!formData.idpedido) {
      alert("Error: El ID del pedido es obligatorio.");
      return;
    }

    if (formData.sNombreEstadoPedido === "CREADO" && clienteEditado) {
      const clienteExiste = clientes.some(
        (c) => c.iCodigo === formData.iCodigoCliente,
      );
      if (!formData.iCodigoCliente || !clienteExiste) {
        alert("Debe seleccionar un cliente válido de la lista.");
        return;
      }
    }

    // Función para formatear fechas en formato MySQL TIMESTAMP
    const formatTimestamp = (date) => {
      if (!date) return null; // Si la fecha es null o undefined
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // Procesar fechas
    const updatedFormData = {
      ...formData,
      fecha_pedido: formatTimestamp(formData.fecha_pedido), // Añadir la fecha del pedido
      fecha_llegada_a_bodega: formatTimestamp(formData.fecha_llegada_a_bodega),
      fecha_llegada_a_bodega_estimada: formatTimestamp(
        formData.fecha_llegada_a_bodega_estimada,
      ),
      usrmodificacion: "UsuarioActual", // Cambia por el usuario actual
    };

    // Llamar a la función onSave con los datos actualizados
    onSave(updatedFormData);
  };

  const handleDeleteImagen = async (columnName) => {
    if (!window.confirm("¿Estás seguro de que deseas eliminar esta imagen permanentemente?")) {
      return;
    }

    try {
      const response = await fetchWithAuth(`${API_URL}/api/borrar-imagen`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idPedido: formData.idpedido,
          columnName: columnName
        }),
      });

      if (response.ok) {
        // Actualizar el estado local para reflejar el borrado inmediatamente
        setImagenes(prev => prev.filter(img => img.columnName !== columnName));
        console.log(`✅ Imagen (${columnName}) eliminada correctamente`);
      } else {
        const errorData = await response.json();
        alert(`Error al borrar la imagen: ${errorData.error || 'Desconocido'}`);
      }
    } catch (error) {
      console.error("Error en la solicitud de borrado:", error);
      alert("Error de conexión al intentar borrar la imagen.");
    }
  };

  return (
    <Dialog
      header={t.titulo}
      visible={isOpen}
      style={{ width: "75vw" }}
      modal
      onHide={onClose}
    >
      <div className="p-fluid form-grid">
        {/* ID Pedido (Solo Lectura) */}
        <div className="field">
          <label htmlFor="idpedido">{t.campos.idpedido}</label>
          <InputText
            id="editar-pedido-idpedido-input"
            value={formData.idpedido}
            readOnly
            className="readonly-field"
          />
        </div>

        <div className="field">
          <label htmlFor="cliente">{t.campos.iCodigoCliente}</label>
          {formData.sNombreEstadoPedido === "CREADO" ? (
            <AutoComplete
              id="editar-pedido-cliente-input"
              value={formData.sNombreCliente || ""}
              suggestions={clientes}
              completeMethod={buscarClientes}
              field="label"
              placeholder="Buscar cliente activo..."
              onChange={(e) => {
                const value = e.target.value;
                console.log("Cambio en searchTermCliente:", value);
                setClienteEditado(true);
                setFormData((prev) => ({
                  ...prev,
                  sNombreCliente: value,
                  iCodigoCliente: null, // Al escribir a mano, limpiamos el código
                }));
              }}
              onSelect={handleClienteSelect}
              className="p-inputtext"
              dropdown={false}
            />
          ) : (
            <InputText
              id="editar-pedido-cliente-readonly"
              value={formData.sNombreCliente || ""}
              readOnly
              className="readonly-field"
            />
          )}
        </div>

        {/* Fecha del Pedido */}
        <div className="field">
          <label htmlFor="fecha_pedido">{t.campos.fecha_pedido}</label>
          <Calendar
            id="editar-pedido-fecha-pedido"
            name="fecha_pedido"
            value={
              formData.fecha_pedido ? new Date(formData.fecha_pedido) : null
            }
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                fecha_pedido: e.value,
              }))
            }
            showTime
            dateFormat="dd/mm/yy"
            hideOnDateTimeSelect={true}
          />
        </div>

        {/* Estado del Pedido (Solo Lectura) */}
        <div className="field">
          <label htmlFor="estadoPedido">{t.campos.estadoPedido}</label>
          <InputText
            id="editar-pedido-estado-readonly"
            value={formData.sNombreEstadoPedido || ""}
            readOnly
            className="readonly-field"
          />
        </div>

        {/* Fecha Llegada a Bodega */}
        <div className="field">
          <label htmlFor="fecha_llegada_a_bodega">
            {t.campos.fecha_llegada_a_bodega}
          </label>
          <Calendar
            id="editar-pedido-fecha-llegada"
            value={
              formData.fecha_llegada_a_bodega
                ? new Date(formData.fecha_llegada_a_bodega)
                : null
            }
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                fecha_llegada_a_bodega: e.value,
              }))
            }
            showTime
            dateFormat="dd/mm/yy"
            hideOnDateTimeSelect={true} // Cierra automáticamente el calendario
          />
        </div>

        {/* Fecha Llegada Estimada a Bodega */}
        <div className="field">
          <label htmlFor="fecha_llegada_a_bodega_estimada">
            {t.campos.fecha_llegada_a_bodega_estimada}
          </label>
          <Calendar
            id="editar-pedido-fecha-estimada"
            value={
              formData.fecha_llegada_a_bodega_estimada
                ? new Date(formData.fecha_llegada_a_bodega_estimada)
                : null
            }
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                fecha_llegada_a_bodega_estimada: e.value,
              }))
            }
            showTime
            dateFormat="dd/mm/yy"
            hideOnDateTimeSelect={true} // Cierra automáticamente el calendario
          />
        </div>

        {/* Origen */}
        <div className="field">
          <label htmlFor="origen">{t.campos.origen}</label>
          <InputText
            id="editar-pedido-origen-input"
            name="origen"
            value={formData.origen || ""}
            onChange={handleInputChange}
          />
        </div>

        {/* Destino */}
        <div className="field">
          <label htmlFor="destino">{t.campos.destino}</label>
          <InputText
            id="editar-pedido-destino-input"
            name="destino"
            value={formData.destino || ""}
            onChange={handleInputChange}
          />
        </div>

        {/* Proveedor */}
        <div className="field">
          <label htmlFor="proveedor">{t.campos.proveedor}</label>
          <InputText
            id="editar-pedido-proveedor-input"
            name="proveedor"
            value={formData.proveedor || ""}
            onChange={handleInputChange}
          />
        </div>

        {/* Observaciones */}
        <div className="field">
          <label htmlFor="observaciones">{t.campos.observaciones}</label>
          <InputTextarea
            id="editar-pedido-observaciones-textarea"
            name="observaciones"
            rows={2}
            value={formData.observaciones || ""}
            onChange={handleInputChange}
          />
        </div>

        {/* TM */}
        <div className="field">
          <label htmlFor="sTM">{t.campos.sTM}</label>
          <InputText
            id="editar-pedido-tm-input"
            name="sTM"
            value={formData.sTM || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="field">
          <label htmlFor="sRegistroIngreso">{t.campos.sRegistroIngreso}</label>
          <InputText
            id="editar-pedido-registro-ingreso-input"
            name="sRegistroIngreso"
            value={formData.sRegistroIngreso || ""}
            onChange={handleInputChange}
          />
        </div>

        {/* [EXPERT_FIX]: Sección de Fotos de Mercancía / Recibo */}
        <div className="field col-12">
          <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
            Fotos de Mercancía / Recibo
          </label>
          {loadingImagenes ? (
            <div className="text-center p-3">
              <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
              <p>Cargando fotos...</p>
            </div>
          ) : imagenes.length > 0 ? (
            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginTop: '10px' }}>
              {imagenes.map((img, index) => (
                <div key={index} style={{
                  textAlign: 'center',
                  border: '1px solid #ddd',
                  padding: '8px',
                  borderRadius: '8px',
                  backgroundColor: '#f9f9f9',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                  <img
                    src={img.thumb}
                    alt={`Mercancía ${index + 1}`}
                    style={{ width: '130px', height: '130px', objectFit: 'cover', borderRadius: '5px', display: 'block', cursor: 'pointer' }}
                    onClick={() => window.open(img.original, '_blank')}
                  />
                  <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'center', gap: '5px' }}>
                    <Button
                      icon="pi pi-eye"
                      className="p-button-rounded p-button-info p-button-sm"
                      onClick={() => window.open(img.original, '_blank')}
                      tooltip="Ver pantalla completa"
                      style={{ width: '30px', height: '30px' }}
                    />
                    <a href={img.original} download={`foto_pedido_${formData.idpedido}_${index + 1}.jpg`} target="_blank" rel="noopener noreferrer">
                      <Button
                        icon="pi pi-download"
                        className="p-button-rounded p-button-success p-button-sm"
                        tooltip="Descargar"
                        style={{ width: '30px', height: '30px' }}
                      />
                    </a>
                    <Button
                      icon="pi pi-trash"
                      className="p-button-rounded p-button-danger p-button-sm"
                      onClick={() => handleDeleteImagen(img.columnName)}
                      tooltip="Borrar imagen"
                      style={{ width: '30px', height: '30px' }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ padding: '15px', border: '1px dashed #ccc', borderRadius: '8px', textAlign: 'center', color: '#888' }}>
              <i className="pi pi-image" style={{ fontSize: '1.5rem', marginBottom: '5px', display: 'block' }}></i>
              <span>No hay fotos registradas para este pedido.</span>
            </div>
          )}
        </div>
      </div>

      <div className="p-dialog-footer">
        <Button
          id="btn-editar-pedido-guardar"
          label={t.guardar}
          icon="pi pi-check"
          className="p-button-success"
          onClick={handleSave}
        />
        <Button
          id="btn-editar-pedido-cancelar"
          label={t.cancelar}
          icon="pi pi-times"
          className="p-button-secondary"
          onClick={onClose}
        />
      </div>
    </Dialog>
  );
};

export default EditarPedidoModal;
